/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomError,
    CustomErrorFromJSON,
    CustomErrorFromJSONTyped,
    CustomErrorToJSON,
    TransactionDto,
    TransactionDtoFromJSON,
    TransactionDtoFromJSONTyped,
    TransactionDtoToJSON,
} from './';

/**
 * The response with a objects of type "T".
 * @export
 * @interface TransactionDtoResponseItemViewModel
 */
export interface TransactionDtoResponseItemViewModel {
    /**
     * Gets the list of errors.
     * @type {Array<CustomError>}
     * @memberof TransactionDtoResponseItemViewModel
     */
    readonly errors?: Array<CustomError> | null;
    /**
     * 
     * @type {TransactionDto}
     * @memberof TransactionDtoResponseItemViewModel
     */
    item?: TransactionDto;
}

export function TransactionDtoResponseItemViewModelFromJSON(json: any): TransactionDtoResponseItemViewModel {
    return TransactionDtoResponseItemViewModelFromJSONTyped(json, false);
}

export function TransactionDtoResponseItemViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionDtoResponseItemViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(CustomErrorFromJSON)),
        'item': !exists(json, 'item') ? undefined : TransactionDtoFromJSON(json['item']),
    };
}

export function TransactionDtoResponseItemViewModelToJSON(value?: TransactionDtoResponseItemViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item': TransactionDtoToJSON(value.item),
    };
}


